/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import Navbar from './components/Navbar'
import SectionHome from './sections/SectionHome'
import Footer from './components/Footer'
import Loading from './components/Loading'
import SectionIWant from './sections/SectionIWant'
import SectionControl from './sections/SectionControl'
import SectionCardsActive from './sections/SectionCardsActive'
import SectionFreeWay from './sections/SectionFreeWay'
import SectionFan from './sections/SectionFan'
import SectionCircuit from './sections/SectionCircuit'
import './App.css'

export default function App() {
  return (
    <>
      <Navbar />
      <SectionHome />
      <SectionCircuit />
      <SectionFan />
      <SectionFreeWay />
      <SectionCardsActive />
      <SectionControl />
      <SectionIWant />
      <Footer />
      <Loading />
    </>
  )
}
